import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["tab"]

  switch(e) {
    const panelId = e.params.panel
    if (!panelId) return

    // Update tab active states
    this.tabTargets.forEach(tab => tab.classList.remove("active"))
    e.currentTarget.classList.add("active")

    // Toggle panel visibility
    const container = this.element.parentElement
    const panels = container.querySelectorAll("[id^='sidebar']")
    panels.forEach(panel => {
      if (panel.id === panelId) {
        panel.classList.remove("d-none")
      } else if (panel.id.startsWith("sidebar") && panel.id.endsWith("Content")) {
        panel.classList.add("d-none")
      }
    })
  }
}
